import { isObject } from '@/utility/objects';

import { ActiveOptimizelyDecision } from '.';

interface IBlogStaysBannerData {
  banner_cta_copy: string;
  banner_cta_url: string;
  banner_subtitle: string;
  banner_title: string;
}

// Refine optimizely variable into a module order variable
const isBlogStaysBannerData = (optVars: unknown): optVars is IBlogStaysBannerData => {
  if (
    optVars &&
    isObject(optVars) &&
    typeof optVars.banner_cta_copy === 'string' &&
    typeof optVars.banner_cta_url === 'string' &&
    typeof optVars.banner_subtitle === 'string' &&
    typeof optVars.banner_title === 'string' &&
    !!optVars.banner_cta_url &&
    !!optVars.banner_title
  ) {
    return true;
  }
  return false;
};

export const getBlogBannerDataFromOptimizely = (
  decision?: ActiveOptimizelyDecision | null,
): IBlogStaysBannerData | undefined => {
  const vars = decision?.variables;
  if (!isBlogStaysBannerData(vars)) return;
  return vars;
};
